import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { errorMessage } from "../../../../utils/notificationUtils";
import { fetchResubmissionDataServiceCghsNew } from "../../../../apis/SchemeService/CGHS/cghsService";
import ViewResubmissionCghs from "../../../../components/patient/Resubmission/CGHS/ViewResubmissionCghs";
import { Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

type ViewResubmissionContainerCghsNewProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
  handleResubmission?: any;
};

const ViewResubmissionContainerCghsNew: FC<
  ViewResubmissionContainerCghsNewProps
> = ({ activeKey, sseData, sseUpdateCount, handleResubmission }) => {
  const { patients, preAuth } = useSelector((state: RootState) => state);
  const [resubmissionData, setResubmissionData] = useState<any>([]);
  const [isFetchingResubmissionData, setIsFetchingResubmissionData] =
    useState<boolean>(false);

  const dischargeStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) => stage?.visitStage === "Discharge",
  );
  const preAuthStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) => stage?.visitStage === "PreAuth",
  );

  const isDischargeSubmitted =
    dischargeStage?.state === "Submitted" ||
    dischargeStage?.state === "Initiated" ||
    dischargeStage?.state === "Manually Submitted" ||
    dischargeStage?.completed;

  const isPreAuthCompleted = preAuthStage?.completed;

  const isResubmissionTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId,
    );

    return (
      currentStage?.visitStage?.toUpperCase() === "Resubmission"?.toUpperCase()
    );
  };

  const fetchResubmissionData = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        setIsFetchingResubmissionData(true);
        const res: any = await fetchResubmissionDataServiceCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
        );
        if (res && Array.isArray(res)) {
          setResubmissionData(res);
        }
        setIsFetchingResubmissionData(false);
      }
      // Fetch portal meta data
    } catch (error: any) {
      errorMessage(error.message || "Please, Try again later");
      setIsFetchingResubmissionData(false);
    }
  };

  useEffect(() => {
    if (isResubmissionTabActive()) fetchResubmissionData();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  return (
    <div>
      <div style={{display: "flex", justifyContent: "flex-end"}}>
        {isPreAuthCompleted && !isDischargeSubmitted && (
          // <Col>
          <Button
            type="primary"
            icon={<PlusCircleOutlined/>}
            style={{
              backgroundColor: "#00549e",
              boxShadow: "0px 2px 8px 0px #00000040",
              borderRadius: "10px",
              marginBottom: 20
            }}
            onClick={() => {
              handleResubmission();
            }}
          >
            Add New Resubmission
          </Button>
          // </Col>
        )}
      </div>
      <ViewResubmissionCghs
        // viewResubmissionCghs={viewResubmissionCghs}
        // closeViewResubmissionModal={closeViewResubmissionModal}
        isFetchingResubmissionData={isFetchingResubmissionData}
        resubmissionList={resubmissionData}
        isCghsNew={true}
      />
    </div>
  );
};

export default ViewResubmissionContainerCghsNew;
